import { t } from '@lingui/core/macro';

import { getLocale } from '../i18n';
import { getOrCreateNumberFormatter } from './getOrCreateNumberFormat';

export interface FormatPercentageOptions {
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    ifNaN?: string;
    roundingMode?: Intl.NumberFormatOptions['roundingMode'];
}

const defaults: FormatPercentageOptions = {
    minimumFractionDigits: 1,
};

export function formatPercentage(number: number, { ifNaN, ...opts }: FormatPercentageOptions = defaults): string {
    if (ifNaN !== undefined && isNaN(number)) {
        return ifNaN;
    }
    if (isNaN(number)) {
        return t`Unknown` + ' %';
    }
    const intlOpts: Intl.NumberFormatOptions = {
        style: 'percent',
        ...opts,
    };
    return getOrCreateNumberFormatter(getLocale(), intlOpts).format(number);
}
